import { createBrowserRouter, Navigate } from 'react-router-dom';
import { ErrorFallbackScreen } from 'components/screens';
import { PATHS } from 'config/paths';
import {
  AccountPage,
  AppLandingPage,
  AssignmentDetailsPage,
  AssignmentsPage,
  AuthenticationErrorPage,
  ContactZenjobPage,
  DeleteProfilePage,
  GeolocationPermissionsPage,
  LanguageSettingsPage,
  LoginPage,
  NotificationSettingsPage,
  PrivacySettingsPage,
  ReasonDetailsPage,
  ShiftDetailsPage,
  WeekDetailsPage,
  WeeksPage,
  WorkPage
} from 'modules/routes';
import { AuthGuard } from './utils/auth';
import { Auth0ProviderWithNavigate } from './utils/auth/components/Auth0ProviderWithNavigate';

// eslint-disable-next-line react-refresh/only-export-components
const RedirectToWeeks = () => <Navigate to={PATHS.weeks} replace />;

export const router = createBrowserRouter([
  {
    children: [
      {
        path: PATHS.app,
        element: <AppLandingPage />
      },
      {
        path: PATHS.error,
        element: <AuthenticationErrorPage />
      },
      {
        element: <Auth0ProviderWithNavigate />,
        errorElement: <ErrorFallbackScreen />,
        children: [
          {
            path: PATHS.root,
            element: <AuthGuard component={RedirectToWeeks} />
          },
          {
            path: PATHS.login,
            element: <LoginPage />
          },
          {
            path: PATHS.weeks,
            element: <AuthGuard component={WorkPage} />,
            children: [
              {
                index: true,
                element: <WeeksPage />
              },
              {
                path: PATHS.weekDetails,
                children: [
                  {
                    index: true,
                    element: <WeekDetailsPage />
                  },
                  {
                    path: PATHS.shiftDetails,
                    children: [
                      {
                        index: true,
                        element: <ShiftDetailsPage />
                      }
                    ]
                  },
                  {
                    path: PATHS.reasonDetails,
                    children: [
                      {
                        index: true,
                        element: <ReasonDetailsPage />
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            path: PATHS.account,
            children: [
              {
                index: true,
                element: <AuthGuard component={AccountPage} />
              },
              {
                path: PATHS.languageSettings,
                element: <AuthGuard component={LanguageSettingsPage} />
              },
              {
                path: PATHS.privacySettings,
                children: [
                  {
                    index: true,
                    element: <AuthGuard component={PrivacySettingsPage} />
                  },
                  {
                    path: PATHS.geolocation,
                    element: (
                      <AuthGuard component={GeolocationPermissionsPage} />
                    )
                  }
                ]
              },
              {
                path: PATHS.contactZenjob,
                element: <AuthGuard component={ContactZenjobPage} />
              },
              {
                path: PATHS.deleteProfile,
                element: <AuthGuard component={DeleteProfilePage} />
              },
              {
                path: PATHS.assignments,
                children: [
                  {
                    index: true,
                    element: <AuthGuard component={AssignmentsPage} />
                  },
                  {
                    path: PATHS.assignmentDetails,
                    element: <AuthGuard component={AssignmentDetailsPage} />
                  }
                ]
              },
              {
                path: PATHS.notificationSettings,
                element: <AuthGuard component={NotificationSettingsPage} />
              }
            ]
          },
          {
            path: '*',
            element: <AuthGuard component={ErrorFallbackScreen} />
          }
        ]
      }
    ]
  }
]);
